import { Box, HStack, Text } from "@chakra-ui/react";
import React from "react";
import { WarningFillIcon, XmarkIcon } from "../../styles/icons";
import { CherryPayApi } from "../../api/models";

interface RiskWarningBannerProps {
  riskLevel: CherryPayApi.CherryPassNotificationScheduleReviewRiskLevel;
  riskRatingReason: string;
}

interface RiskTheme {
  bgColor: string;
  borderColor: string;
  iconColor: string;
  icon: React.ComponentType<any>;
}

const getRiskTheme = (
  riskLevel: CherryPayApi.CherryPassNotificationScheduleReviewRiskLevel
): RiskTheme | null => {
  switch (riskLevel) {
    case "MediumRisk":
      return {
        bgColor: "riskRating.reviewRequired.bg",
        borderColor: "riskRating.reviewRequired.border",
        iconColor: "riskRating.reviewRequired.icon",
        icon: WarningFillIcon,
      };
    case "HighRisk":
      return {
        bgColor: "riskRating.highRisk.bg",
        borderColor: "riskRating.highRisk.border",
        iconColor: "riskRating.highRisk.icon",
        icon: XmarkIcon,
      };
    default:
      return null;
  }
};

export const RiskWarningBanner: React.FC<RiskWarningBannerProps> = ({
  riskLevel,
  riskRatingReason,
}) => {
  const theme = getRiskTheme(riskLevel);

  if (!theme) {
    return null;
  }

  const IconComponent = theme.icon;

  return (
    <Box
      bg={theme.bgColor}
      border="1px solid"
      borderColor={theme.borderColor}
      borderRadius="md"
      p={3}
      mt={2}
    >
      <HStack spacing={2} alignItems="flex-start">
        <IconComponent color={theme.iconColor} boxSize={5} mt={0.5} />
        <Text fontSize="sm" color="gray.700">
          {riskRatingReason}
        </Text>
      </HStack>
    </Box>
  );
};
